import React from 'react'
import { withIcon } from '../../withIcon'

function SlideLastIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.5 18.5793L7.5 5.42024C7.5 5.25505 7.58423 5.10438 7.71441 5.03629C7.84362 4.96933 7.99581 4.99611 8.10206 5.10772L14.3859 11.6872C14.538 11.8457 14.538 12.1538 14.3859 12.3134L8.10206 18.8918C7.99581 19.0034 7.84362 19.0313 7.71441 18.9632C7.58423 18.8962 7.5 18.7456 7.5 18.5793Z" fill={color}/>
      <path d="M16.5 5H15.5V19H16.5V5Z" fill={color}/>
    </svg>
  )
}

export default withIcon(SlideLastIcon)
